'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import {CampaignCard, uniqueCampaigns} from '@/components/campaigns/CampaignsGrid'
import type {CampaignDocument} from '@/types/sanity'

type CampaignsCarouselClientProps = {
  campaigns: CampaignDocument[]
}

export function CampaignsCarouselClient({campaigns}: CampaignsCarouselClientProps) {
  const dedupedCampaigns = uniqueCampaigns(campaigns)
  if (!dedupedCampaigns.length) return null

  return (
    <Carousel
      opts={{
        align: 'start',
        slidesToScroll: 1,
        containScroll: 'trimSnaps',
      }}
      className="relative mt-site-lg"
    >
      <CarouselContent>
        {dedupedCampaigns.map((campaign) => (
          <CarouselItem key={campaign._id} className="basis-full">
            <CampaignCard campaign={campaign} cardClassName="shadow-none hover:shadow-none" />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="top-1/2 left-2 -translate-y-1/2 md:-left-12 md:left-auto" />
      <CarouselNext className="top-1/2 right-2 -translate-y-1/2 md:-right-12" />
    </Carousel>
  )
}
